import axios from 'axios'

export function getClient() {
  return axios.create({
    baseURL: '/api',
    timeout: 20000
  })
}
